
import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import GenericBoard from '../Button/ButtonCard/GenericBoard';
import './Card.css';
import BntScorpyos from '../PopUps/BntScorpyos';
import { Box, Typography } from '@mui/material';

/**
 * Scorpyos component renders a card with generic board information.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleGeneric - The callback function to handle generic peripheral board.
 * @param {Function} props.handleGenericDecrement - The callback function to handle decrement of generic peripheral board.
 * @param {Boolean} props.reset - Whether to reset the generic peripheral board.
 */
const Scorpyos = ({
  /**
   * The callback function to handle generic peripheral board.
   */
  handleGeneric, module, handleDecrement,
  /**
   * The callback function to handle decrement of generic peripheral board.
   */
  /**
   * Whether to reset the generic peripheral board.
   */
  reset
}) => {
  const [open, setOpen] = useState(false);

  /**
   * Handles the click event to open the generic peripheral board popup.
   */
  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <Card variant="outlined" sx={{
      /**
       * Custom styles for the card container
       */
      width: '430px',
      height: '200px',
      border: 'none',
      boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
    }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontFamily: 'Open Sans',
              m: 0,
             
              fontWeight: 'bold',
            }}
          >
            Scorpyos                    </Typography>

          <BntScorpyos size="small" onClick={handleClickOpen}>
            
 </BntScorpyos>
        </Box>



        <GenericBoard
        text='Scorpyos'
          onClick={() => handleGeneric(module)}
          handleGenericDecrement={() => handleDecrement(module)}
          reset={reset}
        />


        <p
          style={{
            fontFamily: 'Open Sans',
            fontSize: '12px',
            marginRight: '16%'
          }}
        >
SCORPYOS is a Supervisor for Space Equipments or 
modules, that operates independently or as a supporting 
unit.        </p>

        <div style={{
          /**
           * Custom styles for the button container
           */
          display: 'flex',
          justifyContent: 'flex-end'
        }}>

        </div>
      </CardContent>
    </Card>
  );
};

/**
 * Exports the GenericPeripheral component as the default export.
 */
export default Scorpyos;